import { CardWrapperProps } from "../interface";
import LinkWrap from "../../../shared/LinkWrap/component";
import styles from "../card.module.scss";

const CardWrapper = ({
    renderAsButton,
    cardRef,
    item,
    featureAttribution,
    onClick,
    children,
    ariaLabel,
}: CardWrapperProps) => {
    const { url, external, itemType } = item;
    /**
     * Some cards that open a modal instead of a new page should be rendered as buttons for the following reasons:
     *
     * Semantics and User expectations
     * A <button> semantically represents a button and is designed for interactive actions like triggering JavaScript or opening modals. On the other hand, <a> elements are semantically hyperlinks, intended for navigation between pages. While adding role="button" changes how assistive technologies interpret the element, it does not fully align with user expectations or native behaviour.
     *
     * Keyboard interaction
     * Buttons natively support activation with both Enter and Space. Links, even with role="button", only support Enter unless additional scripting is added to handle Space. Any mismatch in behaviour could disrupt the experience for keyboard users.
     *
     * Assistive technology
     * Native <button> elements provide reliable, predictable behaviour across browsers and assistive technologies.
     *
     */

    if (renderAsButton) {
        return (
            <button
                ref={cardRef as React.Ref<HTMLButtonElement>}
                onClick={
                    onClick as unknown as React.MouseEventHandler<HTMLButtonElement>
                }
                className={styles.cardWrapper}
                data-cy={`type-${itemType || ""}`}
            >
                {children}
            </button>
        );
    }

    return (
        <LinkWrap
            ref={cardRef as React.Ref<HTMLAnchorElement>}
            url={url}
            external={external}
            featureAttribution={featureAttribution}
            className={styles.cardWrapper}
            onClick={
                onClick as unknown as React.MouseEventHandler<HTMLAnchorElement>
            }
            data-cy={`type-${itemType || ""}`}
            aria-label={ariaLabel}
        >
            {children}
        </LinkWrap>
    );
};

export default CardWrapper;
